import { Shirt } from "../../entities/Shirt";
import SquareView from "../ItemView/SquareView";
import AddShirt from "../../img/add_shirt_inside.png";
import ImageButton from "../ImageButton/ImageButton";
import DialogService from "../Dialog/dialogService";
import NewShirtView from "../../pages/NewItem/NewShirtView";
import { Box } from "@mui/system";

const AddShirtButton = () => {
  const { openMD: openDialog } = DialogService();

  const openNewShirt = () => {
    openDialog("Add new shirt", <NewShirtView />, []);
  };

  return <ImageButton width={"100%"} url={AddShirt} onClick={openNewShirt} />;
};

export type ItemListWidthProps = {
  xs?: string;
  sm?: string;
  md?: string;
  lg?: string;
};

interface ItemsListProps {
  shirts: Array<Shirt>;
  showAdd?: boolean;
  justify?: string;
  shouldShowUser?: boolean;
  widthProps?: ItemListWidthProps;
  imgHeight?: number;
}

const ItemsList = ({
  shirts,
  showAdd,
  justify: justifyProps,
  shouldShowUser = true,
  widthProps,
  imgHeight = 80,
}: ItemsListProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: {
          xs: "center",
          sm: justifyProps || "center",
          md: "flex-start",
        },
        rowGap: 2,
        marginTop: "10px",
        width: "100%",
      }}
    >
      {showAdd && (
        <Box
          aria-label="AddShirtCardBox"
          sx={{
            width: {
              xs: "100%",
              sm: "calc(50%)",
              md: "calc(33.33%)",
            },
          }}
          padding={"0px 8px"}
        >
          <AddShirtButton />
        </Box>
      )}

      {shirts.map((item, index) => {
        return (
          <Box
            key={`shirt_${index}`}
            sx={{
              width: widthProps ?? {
                xs: "100%",
                sm: "calc(50%)",
                md: "calc(33.33%)",
              },
            }}
            padding={"0px 8px"}
          >
            <SquareView
              shirt={item}
              imgHeight={imgHeight}
              shouldShowUser={shouldShowUser}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ItemsList;
